import { render, staticRenderFns } from "./MCalendar.vue?vue&type=template&id=25a2fb6f"
import script from "./MCalendar.vue?vue&type=script&lang=js"
export * from "./MCalendar.vue?vue&type=script&lang=js"
import style0 from "./MCalendar.vue?vue&type=style&index=0&id=25a2fb6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports